import { render, staticRenderFns } from "./DichVuGiaiTriList.vue?vue&type=template&id=104fe1da"
import script from "./DichVuGiaiTriList.vue?vue&type=script&lang=js"
export * from "./DichVuGiaiTriList.vue?vue&type=script&lang=js"
import style0 from "./DichVuGiaiTriList.vue?vue&type=style&index=0&id=104fe1da&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports